import React from "react";

interface TextSizeButtonProps {
  size: "small" | "medium" | "large";
  isSelected: boolean;
  onSelect: (size: "small" | "medium" | "large") => void;
}

const getSizeInfo = (size: "small" | "medium" | "large") => {
  switch (size) {
    case "small":
      return {
        icon: "A",
        name: "Small",
        fontSize: "12px",
      };
    case "medium":
      return {
        icon: "A",
        name: "Medium",
        fontSize: "16px",
      };
    case "large":
      return {
        icon: "A",
        name: "Large",
        fontSize: "20px",
      };
  }
};

export const TextSizeButton: React.FC<TextSizeButtonProps> = ({
  size,
  isSelected,
  onSelect,
}) => {
  const info = getSizeInfo(size);

  return (
    <button
      onClick={() => onSelect(size)}
      title={info.name}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0",
        width: "100%",
        height: "100%",
        background: isSelected ? "rgba(62, 106, 225, 0.3)" : "var(--bg-subtle)",
        border: isSelected
          ? "2px solid var(--accent)"
          : "1px solid var(--border)",
        borderRadius: "8px",
        cursor: "pointer",
        transition: "all 0.2s",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Preview area */}
      <div
        style={{
          width: "100%",
          flex: 1,
          position: "relative",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            fontSize: info.fontSize,
            fontWeight: 600,
            color: "var(--text-primary)",
          }}
        >
          {info.icon}
        </div>
      </div>

      {/* Label area */}
      <div
        style={{
          width: "100%",
          padding: "6px 4px",
          background: isSelected
            ? "rgba(62, 106, 225, 0.2)"
            : "rgba(0,0,0,0.2)",
          borderTop: "1px solid rgba(255,255,255,0.1)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "2px",
        }}
      >
        <div
          style={{
            fontSize: "9px",
            color: isSelected ? "var(--text-primary)" : "var(--text-secondary)",
            fontWeight: isSelected ? 600 : 400,
            whiteSpace: "nowrap",
          }}
        >
          {info.name}
        </div>
      </div>
    </button>
  );
};
